import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Button } from "react-bootstrap";
import logo from "../components/Assets/logo-no-background-crop.png";

const Navbar1 = (props) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      bg="dark"
      //fixed="top"
      variant="dark"
      expand="sm"
      expanded={expanded}
      className="p-4"
    >
      <Navbar.Brand
        font-weight="bold"
        font-aria-setsize={20}
        as={Link}
        exact
        to="/"
      >
        <img
          alt=""
          src={logo}
          // src="https://i.postimg.cc/25J2XxXp/Logo.png"
          // src="https://i.postimg.cc/tJrzfRTy/logo-no-background.png"
          width="30"
          height="30"
          style={{ marginRight: 5 }}
          className="d-inline-block align-top"
        />
        Lot Ninja
      </Navbar.Brand>

      <Navbar.Toggle
        aria-controls="basic-navbar-nav"
        onMouseEnter={() =>
          setExpanded((prevExpanded) => (prevExpanded = !prevExpanded))
        }
      />

      <Navbar.Collapse
        id="basic-navbar-nav"
        onMouseLeave={() =>
          setExpanded((prevExpanded) => (prevExpanded = !prevExpanded))
        }
      >
        <Nav className="mr-auto" onClick={() => setExpanded(false)}>
          <Nav.Link as={Link} exact to="/">
            Home
          </Nav.Link>
          <Nav.Link as={Link} to="/Lots">
            Parking Lots
          </Nav.Link>
          <Nav.Link as={Link} to="/Map">
            Map
          </Nav.Link>
          <Nav.Link as={Link} to="/about">
            About
          </Nav.Link>
          <Nav.Link as={Link} to="/Contact_Us">
            Contact Us
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>


               
                
    

      <Nav></Nav>
      <Button onClick={props.clearToken} variant="outline-light">
        Log Out{" "}
      </Button>
    </Navbar>
  );
};

export default Navbar1;

//import React from 'react';
//import { Container, Navbar, NavbarBrand } from 'reactstrap';
//import { Button } from 'reactstrap';
// export default function App() {
//   return (
//     <>
//       <Navbar light bgColor='gray'>
//         <Container fluid>
//           <NavbarBrand>
//             <img src= 'https://www.pngkey.com/png/full/349-3499617_parking-icon-parking-icon-png.png'
//               height='30'
//               alt=''
//               loading='lazy'
//             />
//             NY Parking Map App
//           </NavbarBrand>
//         </Container>
//       </Navbar>
//     </>
//   );
// }

// const Navbar1 = (props) => {
//     return (
//         <nav class= "navbar navbar-light bg-light">
//         <div class="container-fluid">

//             <span class="navbar-brand mb-0 h1">NY Parking Map App</span>

//             <a class="navbar-brand" href="/room">Room</a>

//             { props.token ? <Button onClick={props.clearToken}>Log Out </Button>: null}
//         </div>
//         </nav>
//     );
// }

// export default Navbar1;
